module.exports = __webpack_public_path__ + "static/media/last_banner_7.f7b742e5.png";